import React, { useState, useEffect } from "react";
import TableViewSearch from "../../CustomComponent/TableViewSearch";
import TableView from "../../CustomComponent/TableView";
import useStyles from "../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";
import { decryptData } from "../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Filter from "./Filter";

function ViewSyncDashboard({
  selectedExam,
  cources,
  column,
  setFilterData,
  filterData,
}) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(100);
  const [onPage, setOnPage] = useState(0);

  const [rowCount, setRowCount] = useState("");

  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage);
  };

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editcource") {
      navigate(`/admin/editcource/${rowId}`);
    }
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  function getTimeFromISO(isoString) {
    const date = new Date(isoString);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }

  const rows = (cources || []).map((d, index) => {
      const isLogsNotSynced =
    d?.sync_status === "No" ||
    d?.sync_status === false ||
    d?.sync_status === 0 ||
    !d?.sync_status;
    const row = {
      id: index + 1,
      srno: index + 1,
      branch_name: d?.branch?.center_name,
      center_name: d?.center?.center_name,
      learner_download: d?.learner_download,
      exam_download: d?.exam_download,
      exam_started: d?.exam_started,
      exam_name: d?.exam?.exam_name,
      result_genrate: d?.result_genrate,
      logs_sync_status: d?.logs_sync_status,
      sync_status: d?.sync_status,
      attempt_count: d?.attempt_count || "0",
      live_attempt_count: d?.live_attempt_count || "0",
      logs_count: d?.logs_count || "0",
      live_logs_count: d?.live_logs_count || "0",
      present_count: d?.student_count || "0",
      sync_time: d?.sync_time ? getTimeFromISO(d?.sync_time) : "N/A",
          // 👇 important
    highlightRow: isLogsNotSynced,
    };

    // Fill only the keys that are present in `column` prop
    Object.keys(column).forEach((key) => {
      row[key] = d[key] ?? "N/A";
    });

    return row;
  });

  // Filter rows by search query (across all column values)
  const filteredRows = rows.filter((row) =>
    Object.keys(column).some((key) =>
      String(row[key]).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 20,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
      sortable: true,
    },
    {
      field: "exam_name",
      headerName: "Exam Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 300,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
      sortable: true,
    },
    {
      field: "branch_name",
      headerName: "Branch Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 150,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_name",
      headerName: "Center Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 250,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "learner_download",
      headerName: "Learner Data Download",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_download",
      headerName: "Exam Data Download",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "exam_started",
    //   headerName: "Exam Started",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 250,
    //   sortable: true,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "sync_status",
      headerName: "Sync Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 130,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "result_genrate",
      headerName: "Result Generated",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "logs_sync_status",
      headerName: "Logs Sync Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "sync_time",
      headerName: "Sync Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "present_count",
      headerName: "Present Count",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "attempt_count",
      headerName: "CBT Attempt Count",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "live_attempt_count",
      headerName: "IBT Attempt Count",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "logs_count",
      headerName: "CBT Logs Count",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "live_logs_count",
      headerName: "IBT Logs Count",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: true,
      disableColumnMenu: true,
      autoPageSize: false,
    },
  ];

  const Heading = [
    {
      id: 1,
      inputplaceholder: "Search cource name",
      // export: "yes",
    },
  ];

  const style = [
    {
      height: "maxh60",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "client",
      highlight:'yes',
    },
  ];

  return (
    <>
      <ToastContainer />
      {filteredRows?.length > 0 && (
        <div
          className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
        >
          {/* <TableViewSearch Heading={Heading} onSearch={handleSearch} /> */}
          {/* <Filter filterData={filterData} setFilterData={setFilterData} /> */}
          <TableView columns={columns} rows={filteredRows} Heading={style} />
        </div>
      )}
    </>
  );
}
export default ViewSyncDashboard;
